import clsx from 'clsx';
import { forwardRef, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, className, children, ...rest },
  ref,
) {
  return (
    <span className={clsx('relative inline-flex w-full items-center', className)}>
      <select
        ref={ref}
        {...rest}
        aria-invalid={invalid || undefined}
        className={clsx(
          'block w-full appearance-none rounded-[var(--radius-md)] border bg-bg-base px-3 py-2 pr-9 text-sm text-text-primary',
          'transition-[box-shadow,border-color] duration-[var(--duration-fast)]',
          invalid ? 'border-danger' : 'border-border-subtle',
        )}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-2.5 h-4 w-4 text-text-muted"
      />
    </span>
  );
});
